import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Avatar, Stack } from '@mui/material';
import CallToAction from '../widgets/CallToAction';
import GroupIcon from '@mui/icons-material/Group';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HandshakeIcon from '@mui/icons-material/Handshake';

export default function PresentationAssociations() {
    const benefits = [
        {
            icon: <GroupIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
            title: "Touchez plus d'étudiants",
            description: "Diffusez vos événements auprès de milliers d'étudiants cibles (écoles, de commerces, ingénieurs, médecins, etc..)."
        },
        {
            icon: <TrendingUpIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
            title: "Développez votre réseau de partenaires",
            description: "Etablissez de nouveaux partenariats et trouvez des entreprises pour sponsoriser vos événements."
        },
        {
            icon: <TrendingUpIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
            title: "Valorisez votre image ",
            description: "Mettez en avant vos membres ainsi que l'image de votre association auprès des recruteurs."
        },
        {
            icon: <HandshakeIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
            title: "100% Gratuit",
            description: "Bénéficiez d'accès privilégiés aux entreprises partenaires pour des événements et opportunités exclusives."
        }
    ];



    return (
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
            <Helmet>
                <title>Associations — Partenariats, événements, visibilité | Student Link</title>
                <meta name="description" content="Touchez plus d'étudiants et d'entreprises, développez vos partenariats et valorisez votre image. 100% gratuit." />
                <link rel="canonical" href="https://studentlink.fr/associations" />
            </Helmet>
            {/* HERO */}
            <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
                <Typography
                    variant="h2"
                    component="h1"
                    sx={{ fontWeight: 700, lineHeight: 1.1, color: 'text.primary', fontSize: { xs: 42, md: 56 } }}
                >
                    Touchez un maximum d'étudiants et d'entreprises
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 880, mx: 'auto', mt: 2, fontWeight: 400 }}>
                    Devenez un acteur incontournable du recrutement étudiant !
                </Typography>
            </Box>

            {/* BÉNÉFICES */}
            <Grid container spacing={4} sx={{ mb: { xs: 8, md: 12 } }}>
                {benefits.map((benefit, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Card
                            elevation={0}
                            sx={{
                                height: '100%',
                                textAlign: 'center',
                                p: 3,
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 8,
                            }}
                        >
                            <CardContent>
                                <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                                    <Box
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: 64,
                                            height: 64,
                                            borderRadius: 8,
                                            backgroundColor: 'rgba(0,117,255,0.08)'
                                        }}
                                    >
                                        {benefit.icon}
                                    </Box>
                                </Box>
                                <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: 'text.primary' }}>
                                    {benefit.title}
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    {benefit.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>



            {/* CTA */}
            <Box sx={{ mt: { xs: 6, md: 10 } }}>
                <CallToAction
                    title="Prêt à rejoindre notre communauté ?"
                    subtitle="Découvrez comment Student Link aide votre association à mieux accompagner ses membres dans leur parcours professionnel."
                    actions={(
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                            <Button component="a" href="https://plateforme-asso.studentlink.fr/" target="_blank" rel="noopener noreferrer" variant="contained" sx={{ height: 48, borderRadius: 4, px: 3 }}>Connexion/Inscription</Button>
                            <Button component="a" href="https://calendly.com/j-derosnay-studentlink/30min" target="_blank" rel="noopener noreferrer" variant="outlined" sx={{ height: 48, borderRadius: 4, px: 3 }}>Demander une démo</Button>
                        </Stack>
                    )}
                />
            </Box>
        </Container>
    );
}